import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.shopReviews.header',
    defaultMessage: 'Opiniones',
  },
  noReviewsTitle: {
    id: 'app.shopReviews.noReviewsTitle',
    defaultMessage: 'El restaurante aún no posee opiniones',
  },
  noReviewsSubtitle: {
    id: 'app.shopReviews.noReviewsSubtitle',
    defaultMessage: '¡Sé el primero en opinar luego de hacer un pedido!',
  },
});
